import { Typography } from 'react-md';
import { TTI_LOCATIONS } from './const';

import styles from './start-page-location.module.scss';

interface Props {
    region?: string;
}

export function StartPageLocation({ region }: Props) {
    if (!region) return null;

    const { country, flag: _flag, city } = TTI_LOCATIONS[region];
    const { origin } = window.location;
    const flag = origin + _flag;

    return (
        <div className={styles['location-container']}>
            <Typography>{country}</Typography>
            <img src={flag} alt={region} />
            <Typography>{city}</Typography>
        </div>
    );
}
